import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PermissionGuard } from '@/components/PermissionGuard';
import { GERAL_VALUE } from '../constants';

interface ReportsListHeaderProps {
  onNewReport: () => void;
  partnerFilter?: string;
  partnerOptions?: Array<{ value: string; label: string }>;
}

export const ReportsListHeader: React.FC<ReportsListHeaderProps> = ({
  onNewReport,
  partnerFilter = GERAL_VALUE,
  partnerOptions = [],
}) => {
  const hasPartnerFilter = partnerFilter && partnerFilter !== GERAL_VALUE;
  const partnerLabel = hasPartnerFilter
    ? (partnerOptions.find((o) => o.value === partnerFilter)?.label || null)
    : null;
  const title = partnerLabel ? `Reports de ${partnerLabel}` : 'Reports';

  return (
    <div className="space-y-4 gap-2 lg:space-y-0 lg:flex lg:items-center lg:justify-between">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold leading-6 text-gray-900 sm:text-xl lg:text-2xl">
          {title}
        </h2>
        <p className="text-sm text-muted-foreground sm:text-base max-w-2xl">
          Confira os reports feitos no Culture Monitor
        </p>
      </div>
      <PermissionGuard action="create_reports">
        <Button
          size="sm"
          variant="dark"
          onClick={onNewReport}
          className="flex items-center justify-center gap-2 h-10 sm:h-9 px-3 sm:px-4 shrink-0"
        >
          <Plus className="h-4 w-4 text-white" />
          <span className="hidden sm:inline text-white">Novo Report</span>
        </Button>
      </PermissionGuard>
    </div>
  );
};
